import React, {useEffect, useContext} from 'react';
import { Box, Button, Stack, TableCell, TextField, Typography, IconButton, Dialog, Backdrop, CircularProgress } from '@mui/material';
import {Context} from '../App';
import SorTableCheckable from '../components/ui/sortable-checkable';
import { Add, DeleteForever, Edit, InfoOutlined } from '@mui/icons-material';
import Header from '../components/layout/Header';
import UserForm from '../components/forms/user';
import moment from 'moment';
import 'moment/locale/fr';
import AppLayout from '../components/layout/AppLayout';

export default function Users() {
    const {setIsConnected} = useContext(Context)
    const [load, setLoad] = React.useState(true);
    const [open, setOpen] = React.useState(false);
    const [action, setAction] = React.useState('');
    const [users, setUsers] = React.useState([]);
    const [user, setUser] = React.useState();
    const [selectItems, setItems] = React.useState([]);
    const [searchInput, setSearchInput] = React.useState('');

    const table = [
        {header: "Nom", sortable: true, sortBy:(el)=>el.nom.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize', minWidth:'100px'}}>{row.nom}</TableCell>},
        {header: "Prénom", sortable: true, sortBy:(el)=>el.prenom.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize', minWidth:'100px'}}>{row.prenom}</TableCell>},
        {header: "Type", sortable: true, sortBy:(el)=>el.role, row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize', minWidth:'100px'}}>{row.role==='admin' ? 'administrateur': row.role==='super admin'? 'super admin':'utilisateur'}</TableCell>},
        {header: "Mail", sortable: true, sortBy:(el)=>el.mail, row: (row, index)=><TableCell key={index} sx={{minWidth:'200px', textAlign:'center'}}>{row.mail}</TableCell>},
        {header: "", sortable: false, row: (row, index)=><TableCell key={index} sx={{minWidth:'180px', textAlign:'end'}} >
            <IconButton aria-label="informations complémentaires" onClick={()=>{setUser(row); manage_dialog(true, 'info')}}><InfoOutlined fontSize="small"/></IconButton>
            <IconButton aria-label="supprimer" onClick={()=>{setUser(row); manage_dialog(true, 'delete')}}><DeleteForever fontSize="small"/></IconButton>
            <IconButton aria-label="modifier" onClick={()=>{setUser(row); manage_dialog(true, 'edit')}}><Edit fontSize="small"/></IconButton>
        </TableCell>}
    ]

    function normalize(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s-.€]/gi,'').toLowerCase()
    }

    function get_searchable(item) {
        return item.nom+' '+item.prenom+' '+item.mail
    }

    function searchFilter(a, b) {
        return normalize(get_searchable(a)).includes(normalize(b))
    }

    function manage_dialog(status, action='') {
        setOpen(status)
        setAction(action)
        if(!status) {
            setUser()
        }
    }

    async function showResult(result) {
        manage_dialog(true, result ? 'success' : 'echec')
        await new Promise(resolve => setTimeout(resolve, 3000))
        manage_dialog(false)
    }

    useEffect(() => {
        const query = new URLSearchParams({}).toString();

        fetch(process.env.REACT_APP_API_URL.concat('/adm/users?'+query), {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                setIsConnected(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                }
                if (response.status === 200) {
                    const json = await response.json();
                    setUsers(json);
                }
            }
        }).catch(error => {
            console.error("Error fetching projects:", error);
        }).finally(() => {
            setLoad(false);
        });
    }, []);

    return(
        <AppLayout>
            <Box flex={1} display='flex' flexDirection='column' sx={{padding:2}}>
                <Typography variant='h4' marginBlock={3} align='center'>
                    Gestionnaire d'Utilisateurs
                </Typography>

                <Stack direction="row" spacing={2} marginBottom={1.5} alignItems='center' justifyContent={'space-between'}>
                    <TextField value={searchInput} onChange={(e)=>setSearchInput(e.target.value)} label="Rechercher un utilisateur..." variant="outlined" size="small" sx={{width:'60%'}}/>
                    {/* <Button variant="contained" color="primary" onClick={()=>manage_dialog(true, 'add')} startIcon={<Add/>}>
                        Nouveau
                    </Button> */}
                </Stack>

                <SorTableCheckable {...{data:users.filter(reg=>searchFilter(reg, searchInput)),table, selectItems, setItems, rowsPerPage:100, rowsPerPageOptions:[50,100, 300]}}/>
            </Box>

            <Dialog {...{open, onClose:()=>manage_dialog(false), maxWidth:'md', fullWidth:true}}>
                {action === 'add' && <UserForm {...{close:()=>manage_dialog(false), setUsers, showResult}}/>}
                {action === 'edit' && <UserForm {...{close:()=>manage_dialog(false), user, setUsers, showResult}}/>}
            </Dialog>

            <Backdrop open={load}><CircularProgress/></Backdrop>
        </AppLayout>
    )
}

